// src/Views/Footer.js — Flasher footer with mono identity row + watermark.
import React from 'react';
import { LogoMark } from '../components/primitives';

const Footer = () => {
  return (
    <footer
      style={{
        position: 'relative',
        padding: '60px 28px 80px',
        borderTop: '1px solid var(--line)',
        zIndex: 2,
        marginTop: 40,
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 24,
          flexWrap: 'wrap',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <LogoMark />
          <div
            style={{
              fontFamily: 'var(--f-mono)',
              fontSize: 13,
              color: 'var(--ink-3)',
              letterSpacing: '0.04em',
              lineHeight: 1.5,
            }}
          >
            <div style={{ color: 'var(--ink)' }}>Design by Dialogue.AI</div>
            <div>© 2026 · Solomon Foshko</div>
          </div>
        </div>
        <div
          style={{
            fontFamily: 'var(--f-mono)',
            fontSize: 11,
            color: 'var(--ink-3)',
            letterSpacing: '0.16em',
            textTransform: 'uppercase',
            display: 'flex',
            alignItems: 'center',
            gap: 16,
            flexWrap: 'wrap',
          }}
        >
          <a
            href="https://www.linkedin.com/in/solomonfoshko/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--ink-3)' }}
          >
            LINKEDIN
          </a>
          <a
            href="mailto:solomon.foshko@designbydialogue.ai"
            style={{ color: 'var(--ink-3)' }}
          >
            EMAIL
          </a>
          <span>
            <span style={{ color: 'var(--cyan)' }}>●</span> SYSTEMS.ONLINE — AUSTIN, TX
          </span>
        </div>
      </div>

      <div
        aria-hidden="true"
        style={{
          fontFamily: 'var(--f-display)',
          fontSize: 'clamp(80px, 18vw, 280px)',
          fontWeight: 700,
          lineHeight: 0.85,
          letterSpacing: '-0.05em',
          textAlign: 'center',
          marginTop: 60,
          background: 'linear-gradient(180deg, rgba(160,102,255,0.16), transparent 80%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          userSelect: 'none',
          pointerEvents: 'none',
        }}
      >
        dialogue.
      </div>
    </footer>
  );
};

export default Footer;
